/*
*###############################################################################
*Module Name                   : DesignationMaster.js                          #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               : I Dinisuru Balasuriya                         #
*Date                          : Monday, August 30th 2021, 10:14:01 am         #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/

import React, { useState, useEffect } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'
import DPTextBoxforgrid from 'framework/components/DPTextBoxforgrid'
import DPDropDown from 'framework/components/DPDropDown'
import DPSearchBoxDynamic from 'framework/components/DPSearchBoxDynamic'
import { Numeric, Text } from "../../../framework/validators/TextValidation"
import ReactPaginate from 'react-paginate'

const BarcodePrintContent = ({
    CodeValue,
    CodeonChange,
    disabled,
    show,
    AlertMsg,
    AlertColor,
    modelOpen,
    modelTrigger,
    GetSelectRow,
    CodeOnBlur,
    ErrorMsg,
    menuName,
    dataTable,
    SetDataTable,
    strLocCode,
    strLocDesc,
    txnType,
    locCodeOnchange,
    txnTypeOnChange,
    menuCode,
    locationOnBlur,
    txnTypeList,
    GetModeSelectedRow,
    modeModelTrigger,
    modeModelOpen
}) => {
    //*** useState to save table data */
    const ApiURL = window.Links.ApiURL
    const [groupFilter, SetGroupFilter] = useState('a')
    const [currentPage, setCurrentPage] = useState(1)
    const [postsPerPage, setPostsPerPage] = useState(10)
    //*** End of useStates */

    useEffect(() => {
        setCurrentPage(1)
    }, [dataTable.length])

    async function tog_backdrop() {
        modelTrigger();
    }

    async function tog_model_backdrop() {
        modeModelTrigger()
    }

    const defaultSorted = [
        {
            dataField: "id",
            order: "asc",
        },
    ]

    function changeObjectValue(value, id, element) {
        var DataSet = [...dataTable]
        const objectIndex = dataTable.findIndex(obj => obj.id === id);
        const newObject = { ...dataTable[objectIndex], [element]: value };
        DataSet[objectIndex] = newObject
        SetDataTable(DataSet)
    }


    function changeLineQty(value) {
        var DataSet = [...dataTable]

        console.log(value)

        const updatedSet = DataSet.map((item) => {

            return {
                ...item,
                qty: value
            }

        })

        console.log(updatedSet)

        SetDataTable(updatedSet)
    }


    const indexOfLastPost = currentPage * postsPerPage
    const indexOfFirstPost = indexOfLastPost - postsPerPage
    const currentPosts = dataTable.slice(indexOfFirstPost, indexOfLastPost)


    const handlePageClick = (event) => {
        setCurrentPage(event.selected + 1);
    };

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row className='mb-2'>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                    <br />
                                    <small>{ErrorMsg}</small>
                                </Alert>
                            ) : null}
                            <Col sm={12} md={2} className="mb-2-sm">
                                <Label>Location</Label>
                            </Col>
                            <Col sm={12} md={1} className="mb-4-sm" style={{ paddingRight: "0" }}>
                                <DPTextBoxforgrid
                                    textType={'text'}
                                    value={strLocCode}
                                    onChange={locCodeOnchange}
                                    onBlur={locationOnBlur}
                                    disabled={true}
                                />
                            </Col>
                            <Col sm={12} md={3} className="mb-4-sm" style={{ paddingLeft: "0", paddingRight: "0" }}>
                                <DPTextBoxforgrid
                                    textType={'text'}
                                    value={strLocDesc}
                                    disabled={true}

                                />
                            </Col>
                            <Col>
                                <Button
                                    onClick={() => {
                                        tog_backdrop()
                                    }}
                                    color="success"
                                    className="btn-sm"
                                    disabled={disabled}
                                    size="sm"
                                >
                                    <i
                                        className="mdi mdi-search-web"
                                        style={{ fontSize: "12px" }}
                                    ></i>
                                </Button>

                            </Col>
                        </Row>
                        <Row className='mb-2' >
                            <Col sm={12} md={2} className="mb-2-sm">
                                <Label>TransactionType</Label>
                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm" >
                                <DPDropDown
                                    labelHide={true}
                                    colClass={"col-md-0"}
                                    selectedGroup={txnType}
                                    onChange={txnTypeOnChange}
                                    optionGroup={txnTypeList}
                                    disabled={disabled}
                                />
                            </Col>
                        </Row>
                        <Row className='mb-2'>
                            <Col sm={12} md={2} className="mb-2-sm">
                                <Label>Document No</Label>
                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm" style={{ paddingRight: "0" }}>
                                <DPTextBoxforgrid
                                    textType={'text'}
                                    value={CodeValue}
                                    onChange={CodeonChange}
                                    onBlur={CodeOnBlur}
                                    disabled={disabled}
                                />
                            </Col>
                            <Col>
                                <Button
                                    onClick={() => {
                                        tog_model_backdrop()
                                    }}
                                    color="success"
                                    className="btn-sm"
                                    disabled={disabled}
                                    size="sm"
                                >
                                    <i
                                        className="mdi mdi-search-web"
                                        style={{ fontSize: "12px" }}
                                    ></i>
                                </Button>

                            </Col>
                        </Row>
                        <Row>
                            {/* //<a onClick={saveFile} href="#" download={true}> Download Button</a> */}
                            {/* <a href="dat a:text/plain;charset=UTF-8,https://backend.24x7retail.com/temp_print/eb6c66a1164f4ad.txt" download="My Text File">click here</a> */}
                        </Row>

                        <Row>
                            <Col sm={12} md={11} className="mb-2-sm">
                                <table className="table table-striped table-bordered table-sm" id='barcode'>
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Code</th>
                                            <th>Stock Code</th>
                                            <th>Description</th>
                                            <th>Reference</th>
                                            <th>Unit</th>
                                            <th style={{ textAlign: "right" }}>Selling price</th>
                                            <th style={{ textAlign: "right" }}>QTY</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(currentPosts).map((row, index) => (
                                            <TableRow
                                                Key={indexOfFirstPost + index + 1}
                                                FormRow={row}
                                                changeObjectValue={changeObjectValue}
                                                changeLineQty={changeLineQty}
                                            />
                                        ))}
                                    </tbody>
                                </table>
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md="12">
                                <ReactPaginate
                                    previousLabel={'Previous'}
                                    nextLabel={'Next'}
                                    breakLabel={'...'}
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    pageCount={Math.ceil(dataTable.length / postsPerPage)}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    forcePage={currentPage - 1}
                                    renderOnZeroPageCount={null}
                                    activeClassName={'active'}
                                    activeLinkClassName={'page-link'}
                                    containerClassName={'pagination justify-content-start pagination-sm'}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} md={2} className="mb-2-sm">
                                <Label>Total no of Products</Label>
                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm" style={{ paddingRight: "0" }}>
                                <DPTextBoxforgrid
                                    textType={'text'}
                                    textAlign="right"
                                    value={dataTable.length}
                                    disabled={true}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12} md={2} className="mb-2-sm">
                                <Label>Total no of Barcodes</Label>
                            </Col>
                            <Col sm={12} md={4} className="mb-4-sm" style={{ paddingRight: "0" }}>
                                <DPTextBoxforgrid
                                    textType={'text'}
                                    textAlign="right"
                                    value={dataTable.reduce((a, b) => a + (parseFloat(b['qty']) || 0), 0)}
                                    disabled={true}
                                />
                            </Col>
                        </Row>

                        <DPSearchBoxDynamic
                            searchData={[]}
                            columns={[]}
                            defaultSorted={defaultSorted}
                            mainTitle={menuName + " Search"}
                            SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                            isOpen={modelOpen}
                            toggle={modelTrigger}
                            getSelect={GetSelectRow}
                            APIURL={ApiURL}
                            URLPath={"LOCATION"}
                            MenuCode={menuCode}
                            KeyVal={txnType}
                            searchBy={'LOC_CODE'}
                            FilterStr={groupFilter}
                        />

                        <DPSearchBoxDynamic
                            searchData={[]}
                            columns={[]}
                            defaultSorted={defaultSorted}
                            mainTitle={menuName + " Search"}
                            SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                            isOpen={modeModelOpen}
                            toggle={modeModelTrigger}
                            getSelect={GetModeSelectedRow}
                            APIURL={ApiURL}
                            URLPath={txnType}
                            MenuCode={menuCode}
                            KeyVal={txnType}
                            searchBy={'HED_RUNNO'}
                            FilterStr={groupFilter}
                        />

                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    )

}

export default BarcodePrintContent


const TableRow = ({ FormRow, Key, changeObjectValue, changeLineQty }) => {

    return (
        <tr key={FormRow.id}>
            <td style={{ width: "50px" }}>
                <DPTextBoxforgrid
                    textType={'text'}
                    id={'id' + FormRow.id}
                    value={Key}
                    disabled={true}
                />
            </td>
            <td style={{ width: "150px" }}>
                <DPTextBoxforgrid
                    textType={'text'}
                    id={'code' + FormRow.id}
                    value={FormRow.code}
                    disabled={true}
                />
            </td>
            <td style={{ width: "200px" }}>
                <DPTextBoxforgrid
                    textType={'text'}
                    id={'stockcode' + FormRow.id}
                    value={FormRow.stockcode}
                    disabled={true}
                />
            </td>
            <td style={{ width: "450px" }}>
                <DPTextBoxforgrid
                    textType={'text'}
                    id={'name' + FormRow.id}
                    value={FormRow.name}
                    disabled={true}
                />
            </td>
            <td style={{ width: "200px" }}>
                <DPTextBoxforgrid
                    textType={'text'}
                    id={'reference' + FormRow.id}
                    value={FormRow.reference}
                    disabled={false}
                    onChange={(e) => {
                        let reference = Text(e.target, 200, true, true, 'any', true)
                        changeObjectValue(reference, FormRow.id, "reference")
                    }}
                />
            </td>
            <td style={{ width: "100px" }}>
                <DPTextBoxforgrid
                    textType={'text'}
                    id={'unit' + FormRow.id}
                    value={FormRow.unit}
                    disabled={true}
                />
            </td>
            <td style={{ width: "150px", textAlign: "right" }}>
                <DPTextBoxforgrid
                    textType={'text'}
                    textAlign="right"
                    id={'selling' + FormRow.id}
                    value={FormRow.selling}
                    disabled={true}
                />
            </td>
            <td style={{ width: "100px" }}>
                <DPTextBoxforgrid
                    textType={'text'}
                    textAlign="right"
                    value={FormRow.qty}
                    id={FormRow.id}
                    onChange={(e) => {
                        var val1 = Numeric(e.target, 5, 0, false)
                        changeObjectValue(val1, FormRow.id, "qty")

                    }}
                    onBlur={(e) => {

                        var val1 = Numeric(e.target, 5, 0, false)
                        if (val1 == "") {
                            changeObjectValue(0, FormRow.id, "qty")
                        } else {
                            changeObjectValue(val1, FormRow.id, "qty")
                        }
                    }}
                    onKeyDown={(e) => {
                        if (e.key == "Enter") {
                            changeLineQty(e.target.value)
                        }
                    }}
                />
            </td>

        </tr>

    )

}